<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Lobby Display</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Lobby Display</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-12">
            <div class="form-group">
              <PatientsSearchComponent
                @apply-search-click="applySearchClick()"
                :called_by="'LobbyDisplay'"
              ></PatientsSearchComponent>
            </div>
          </div>
        </div>

        <div class="card">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs customtab" role="tablist">
            <li
              class="nav-item"
              v-for="(stage, ndx01) in stagesSteps"
              :key="ndx01"
            >
              <a
                :class="tabPageClass(ndx01)"
                @click="stageClick(ndx01, -1)"
                data-toggle="tab"
                href="#home2"
                role="tab"
                ><span class="hidden-sm-up"></span>
                <span @click="stageClick(ndx01, -1)" class="hidden-xs-down">{{
                  stage.stageName
                }}</span></a
              >
            </li>
          </ul>
          <!-- Tab panes -->

          <div class="tab-content p-3">
            <div
              class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
            >
              <div class="dataTables_length">
                <span style="margin-right: 10px"
                  ><label for="">Show </label>
                </span>
                <select
                  v-model="pageSize"
                  class="form-control form-control-sm"
                  aria-label="Default select example"
                  @change="pageChange(1)"
                >
                  <option selected>50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="2000">2000</option>
                </select>

                <span style="margin-left: 10px">
                  <label for=""> Entries </label></span
                >
              </div>
              <div class="dataTables_filter">
                <span class="float-right">
                  <span style="margin-right: 10px"
                    ><label for="Search">Search:</label></span
                  >
                  <input
                    type="text"
                    @change="SearchDataTable()"
                    v-model="searchFilter"
                    name=""
                    id=""
                  />
                </span>
              </div>
            </div>
            <div class="tab-pane active" id="home2" role="tabpanel">
              <div class="" v-if="activeStageNdx >= 0">
                <table
                  id="home_2"
                  data-height="300"
                  class="table display table-bordered text-center table-striped"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th style="text-align: start">
                        Full Name
                        <span>
                          <button class="asc-desc-btn" @click="orderBy(1)">
                            &uarr; &darr;
                          </button>
                        </span>
                      </th>
                      <th>
                        DOS
                        <span>
                          <button class="asc-desc-btn" @click="orderBy(2)">
                            &uarr; &darr;
                          </button>
                        </span>
                      </th>
                      <th>Step</th>
                    </tr>
                  </thead>

                  <tbody class="text-center">
                    <tr v-if="allFilterPatients.length == 0">
                      <td align="center" colspan="100">
                        <strong> No data available</strong>
                      </td>
                    </tr>
                    <tr
                      v-for="(pat, ndx03) in allFilterPatients"
                      :key="ndx03"
                      v-bind:id="'v' + pat.visitId"
                    >
                      <td>{{ pat.firstName + " " + pat.lastName }}</td>
                      <td>{{ pat.dosdate + " @ " + pat.dostime }}</td>
                      <!-- <td>{{ stepText(pat) }}</td> -->
                      <td><span v-html="stepText(pat)"></span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <nav aria-label="Page navigation">
              <span class="text-left" v-if="totalRows < pageSize * pageNumber"
                >showing {{ totalRows }} of {{ totalRows }} records</span
              >
              <span style="padding-left: 40px" v-else
                >showing {{ pageSize * pageNumber }} of
                {{ totalRows }} records</span
              >
              <ul class="pagination" style="float: right">
                <li class="page-item colorActive">
                  <span v-if="pageNumber == 1">
                    <button
                      disabled
                      class="page-link disabledColor"
                      @click="pageChange('Previous')"
                    >
                      Previous
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange('Previous')">
                      Previous
                    </button>
                  </span>
                </li>

                <li
                  v-for="pageNum in totalPages"
                  :key="pageNum"
                  class="page-item colorActive"
                >
                  <span v-if="pageNumber == pageNum"
                    ><button
                      class="page-link activeColor"
                      disabled
                      @click="pageChange(pageNum)"
                    >
                      {{ pageNum }}
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange(pageNum)">
                      {{ pageNum }}
                    </button></span
                  >
                </li>
                <li class="page-item colorActive">
                  <span v-if="pageNumber == totalPages">
                    <button
                      disabled
                      class="page-link disabledColor"
                      @click="pageChange('Next')"
                    >
                      Next
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange('Next')">
                      Next
                    </button>
                  </span>
                </li>
              </ul>
            </nav>

            <div class="tab-pane p-20" id="profile2" role="tabpanel">2</div>
            <div class="tab-pane p-20" id="messages2" role="tabpanel">3</div>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script src='./jsfiles/LobbyDisplay.js'></script>
<style scoped>
.p-chip {
  background-color: #00c292;
  color: #ffffff;
  border-radius: 16px;
  padding: 0 0.6rem;
  margin-right: 2px;
  margin-top: 2px;
}
#table0012_wrapper {
  margin-top: 70px;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.right-gap {
  margin-right: auto;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: #00c292;
}
input:focus + .slider {
  box-shadow: 0 0 1px #00c292;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
/* Rounded sliders */
.slider.round {
  height: 34px;
  width: 60px;
  border-radius: 24px;
}
.slider.round:before {
  border-radius: 50%;
}
.form-floating-label {
  position: relative;
}
.form-floating-label [type="text"],
.form-floating-label [type="password"],
.form-floating-label [type="date"],
.form-floating-label [type="datetime"],
.form-floating-label [type="datetime-local"],
.form-floating-label [type="month"],
.form-floating-label [type="week"],
.form-floating-label [type="email"],
.form-floating-label [type="number"],
.form-floating-label [type="search"],
.form-floating-label [type="tel"],
.form-floating-label [type="time"],
.form-floating-label [type="url"],
.form-floating-label [type="color"],
.form-floating-label textarea {
  margin-bottom: 0;
  color: black;
  /*            color:#8a8a8a ;
    */
  font-size: 15px;
  font-weight: 300;
  padding: 38px 1rem 1rem 2px;
}
.dummy-label {
  margin-top: -7px;
  margin-bottom: 0;
  color: #343a40;
  font-size: 16px;
  font-weight: bold;
}
.form-floating-label label {
  color: #cacaca;
  font-size: 14px;
  position: absolute;
  pointer-events: none;
  left: 2px;
  bottom: 0;
  transition: all 0.2s ease-in;
  font-weight: 300;
}
.form-floating-label textarea ~ label {
  top: 20px;
  font-size: 18px;
  font-weight: 300;
}
.form-floating-label input:focus ~ label,
.form-floating-label input:disabled[value] ~ label,
.form-floating-label.has-value input ~ label {
  top: 0;
  font-size: 13px;
  color: dodgerblue;
  font-weight: 400;
}
.form-floating-label textarea:focus ~ label,
.form-floating-label.has-value textarea ~ label {
  top: 0;
  font-size: 13px;
  color: dodgerblue;
  font-weight: 400;
}
.float-class1:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 200px;
}
#font1 {
  font-weight: 600;
  font-size: 15px;
  margin-top: -4.5px;
}
#blur {
  color: transparent;
  text-shadow: 0 0 1px #808080;
}
tr {
  height: 55px;
}
/* .label-custom_2 {
    border-radius: 0.2rem;
    height: 18px;
    padding: 2px;
    font-size: 9px;
    margin-top: 5px;
    } */
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* box-shadow: none; */
  width: 98%;
}
.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* box-shadow: none; */
  width: 98%;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
#font1 {
  font-weight: bold;
  font-size: 15px;
  margin-left: -7px;
}
.label_select {
  margin-top: -23px;
  margin-left: 0px;
}
.label_select {
  margin-top: -23px;
  margin-left: 0px;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
.colorActive {
  color: #f95c2e;
}
.disabledColor {
  color: gray;
  background: lightgrey;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
</style>